import React, { useEffect, useMemo, useState } from "react";
import $ from "jquery";
import { CgProfile } from "react-icons/cg";
import { BsRocketFill, BsPersonVideo } from "react-icons/bs";
import { TiMessages } from "react-icons/ti";
import { FaEye, FaRegCalendar, FaPaintRoller } from "react-icons/fa";
import { VscListFlat } from "react-icons/vsc";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { PiCertificateLight } from "react-icons/pi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiExportFill } from "react-icons/ri";
import NavbarCountrySelector from "./NavbarCountrySelector";

// current

const { PUBLIC_URL } = process.env;

const Header = () => {
  const oepAdmin = process.env.REACT_APP_OEPADMIN;
  const oepPortal = process.env.REACT_APP_OEPPORTAL;
  const [displaySubMenuFtrs, setDisplaySubMenuFtrs] = useState(false);
  const [displaySubMenuProducts, setDisplaySubMenuProducts] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const validPaths = useMemo(
    () => [
      "/SkillsAndKnowledgeAssessment",
      "/Reporting",
      "/AI",
      "/Customization",
      "/Feedback",
      "/Proctoring",
      "/Security",
      "/SelfGrading",
      "/Certificates",
    ],
    []
  );

  useEffect(() => {
    $("body").addClass("js");

    const $menu = $("#menu");
    const $menulink = $(".menu-link");

    $menulink.on("click", function (e) {
      e.preventDefault();
      $menulink.toggleClass("active");
      $menu.toggleClass("active");
    });

    return () => {
      $menulink.off("click");
    };
  }, []);

  const handleNavigation = (section) => {
    navigate(`/#${section}`);
  };

  const blurSubMenu = () => {
    setDisplaySubMenuProducts(false);
    setDisplaySubMenuFtrs(false);
  };

  const handleblur = () => {
    setTimeout(() => {
      setDisplaySubMenuProducts(false);
      setDisplaySubMenuFtrs(false);
    }, 300);

    setIsActive({
      home: true,
      features: false,
      courses: false,
      contact: false,
      login: false,
    });

    if (validPaths.includes(location.pathname)) {
      setIsActive({
        home: false,
        features: true,
        courses: false,
        contact: false,
        login: false,
      });
    }
  };

  const handleMenuFtrs = () => {
    setDisplaySubMenuProducts(false);
    setDisplaySubMenuFtrs((prev) => !prev);
  };

  const handleMenuProducts = () => {
    setDisplaySubMenuFtrs(false);
    setDisplaySubMenuProducts((prev) => !prev);
  };

  const [isActive, setIsActive] = useState({
    home: true,
    features: false,
    courses: false,
    contact: false,
    login: false,
  });

  const handleActive = (menu) => {
    if (menu === "home") {
      setIsActive({
        home: true,
        features: false,
        courses: false,
        contact: false,
        login: false,
      });
    }
    if (menu === "features") {
      setIsActive({
        home: false,
        features: true,
        courses: false,
        contact: false,
        login: false,
      });
    }
    if (menu === "courses") {
      setIsActive({
        home: false,
        features: false,
        courses: true,
        contact: false,
        login: false,
      });
    }
    if (menu === "contact") {
      setIsActive({
        home: false,
        features: false,
        courses: false,
        contact: true,
        login: false,
      });
    }
    if (menu === "login") {
      setIsActive({
        home: false,
        features: false,
        courses: false,
        contact: false,
        login: true,
      });
    }
  };
  useEffect(() => {
    if (validPaths.includes(location.pathname)) {
      setIsActive({
        home: false,
        features: true,
        courses: false,
        contact: false,
        login: false,
      });
    }
  }, [location.pathname, validPaths]);

  return (
    <header className="main-header clearfix fixed top-0 left-0 w-full z-50">
      <div className="logo">
        <Link to="/" style={{ cursor: "default" }}>
          <img
            src={`${PUBLIC_URL}/assets/images/NT2.png`}
            alt="logo"
            style={{
              height: "180px",
              width: "180px",
              marginTop: "-75px",
              transform: "rotate(10deg)",
              cursor: "default",
            }}
          />
          {/* <em>Nex</em>Testify */}
        </Link>
      </div>
      <a href="#menu" className="menu-link">
        <i className="fa fa-bars"></i>
      </a>
      <nav id="menu" className="main-nav" role="navigation">
        <ul className="main-menu">
          <li>
            <Link
              to="/"
              className={`${isActive.home && "active"}`}
              onClick={() => {
                window.scrollTo(0, 0);
                blurSubMenu();
                handleActive("home");
              }}
            >
              Home
            </Link>
          </li>

          <li className="has-submenu">
            <Link
              className={`${isActive.features && "active"}`}
              onClick={(e) => {
                e.preventDefault();
                handleMenuFtrs();
                handleActive("features");
              }}
              onBlur={handleblur}
            >
              Features
            </Link>{" "}
          </li>
          {displaySubMenuFtrs && (
            <ul
              className={`submenu sub-features ${
                displaySubMenuFtrs && "show"
              } container`}
            >
              <div className="row">
                <div className="col-lg-6 ftr-col1">
                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/SkillsAndKnowledgeAssessment`}>
                      <span
                        // className="row ftrs-span hover-f1"
                        className={`row ftrs-span hover-f1
                          ${
                            location.pathname ===
                              `/SkillsAndKnowledgeAssessment` && "active"
                          }
                        `}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <CgProfile color="#f5a425" />
                          </span>
                        </span>

                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">
                            Skills and Knowledge Assessment
                          </span>
                          <p className="ftr-p">
                            Make online tests, quizzes and exams
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Reporting`}>
                      <span
                        className={`row ftrs-span hover-f2 ${
                          location.pathname === `/Reporting` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <FaRegCalendar color="#f5a425" />
                          </span>
                        </span>

                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Reporting</span>
                          <p className="ftr-p">
                            Impressive, detailed reporting options{" "}
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/AI`}>
                      <span
                        className={`row ftrs-span hover-f3 ${
                          location.pathname === `/AI` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <BsRocketFill color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">AI Question Generator</span>

                          <p className="ftr-p">
                            Be inspired by AI-generated questions
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Customization`}>
                      <span
                        className={`row ftrs-span hover-f4 ${
                          location.pathname === `/Customization` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <FaPaintRoller color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Customization</span>

                          <p className="ftr-p">
                            Make online tests, quizzes and exams
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Feedback`}>
                      <span
                        className={`row ftrs-span hover-f5 ${
                          location.pathname === `/Feedback` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <TiMessages color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Feedback & Grades</span>

                          <p className="ftr-p">
                            Experience automated feedback and grading
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>
                </div>
                <div className="col-lg-6 ftr-col1">
                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Proctoring`}>
                      <span
                        className={`row ftrs-span hover-f6 ${
                          location.pathname === `/Proctoring` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <FaEye color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Proctoring & Security</span>

                          <p className="ftr-p">
                            Enjoy reliable results every single time
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Security`}>
                      <span
                        className={`row ftrs-span hover-f7 ${
                          location.pathname === `/Security` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <IoShieldCheckmarkSharp color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Security</span>
                          <p className="ftr-p">Your safety is our priority</p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/SelfGrading`}>
                      <span
                        className={`row ftrs-span hover-f8 ${
                          location.pathname === `/SelfGrading` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <VscListFlat color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">
                            Self-grading & Choice questions
                          </span>
                          <p className="ftr-p">
                            Use a variety of test questions
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>

                  <li className="ftrs container">
                    <a href={`${PUBLIC_URL}/Certificates`}>
                      <span
                        className={`row ftrs-span hover-f9 ${
                          location.pathname === `/Certificates` && "active"
                        }`}
                      >
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <PiCertificateLight color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <span className="link">Certificates</span>
                          <p className="ftr-p">
                            Create your own assessment certificates
                          </p>
                        </span>
                      </span>
                    </a>
                  </li>
                </div>
              </div>
            </ul>
          )}

          <li>
            <a
              href={`${PUBLIC_URL}/#section3`}
              className={`
                ${isActive.courses && "active"}
              `}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("section3");
                blurSubMenu();
                handleActive("courses");
              }}
            >
              Courses
            </a>
          </li>
          <li>
            <a
              href={`${PUBLIC_URL}/#section6`}
              className={` 
                ${isActive.contact && "active"}
             `}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("section6");
                blurSubMenu();
                handleActive("contact");
              }}
            >
              Contact
            </a>
          </li>

          <li className="has-submenu">
            <Link
              onClick={(e) => {
                e.preventDefault();
                handleMenuProducts();
                handleActive("login");
              }}
              onBlur={handleblur}
              className={`${isActive.login && "active"}`}
            >
              Login
            </Link>
          </li>
          <NavbarCountrySelector />
          {displaySubMenuProducts && (
            <ul
              className={`submenu sub-features ${
                displaySubMenuProducts && "show"
              } sub-products container`}
            >
              <div className="row">
                <div className="col-lg-6 ftr-col1">
                  <li className="ftrs container">
                    <a
                      href={oepAdmin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="row ftrs-span hover-f1">
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <CgProfile color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <p className="link link-product">Admin Login </p>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li className="ftrs container">
                    <a
                      href={oepAdmin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="row ftrs-span hover-f2">
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <RiExportFill color="#f5a425" />
                          </span>
                        </span>

                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <p className="link link-product">Experts Login</p>
                        </span>
                      </span>
                    </a>
                  </li>
                </div>
                <div className="col-lg-6 ftr-col1">
                  <li className="ftrs container">
                    <a
                      href={oepAdmin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="row ftrs-span hover-f6">
                        <span className="icon col-lg-1 col-sm-1 col-md-1 ">
                          <span className="ftrs-icon">
                            <FaEye color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <p className="link link-product">Proctor Login</p>
                        </span>
                      </span>
                    </a>
                  </li>
                  <li className="ftrs container">
                    <a
                      href={oepPortal}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="row ftrs-span hover-f7">
                        <span className="icon col-lg-1 col-sm-1 col-md-1">
                          <span className="ftrs-icon">
                            <BsPersonVideo color="#f5a425" />
                          </span>
                        </span>
                        <span className="col-lg-11 col-sm-11 col-md-11 feature">
                          <p className="link link-product">Candidate Login</p>
                        </span>
                      </span>
                    </a>
                  </li>
                </div>
              </div>
            </ul>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
